import { useState } from 'react';
import { faqData } from '@/mocks/movies';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100/50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于秋霞影院的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/50 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-100 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-400 text-lg"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}